import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import Cookies from 'js-cookie';

interface PrivateRoutesProps {
  children: ReactNode;
}

export function PrivateRoute({ children }: PrivateRoutesProps) {
  const isAuthenticated = Cookies.get('isAuthenticated');
  // const isAuthenticated = 'true';

  return isAuthenticated === 'true' ? <>{children}</> : <Navigate to="/" />;
}
